import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix as PRE } from 'main/pages/Dashboard/pages/PaymentSettings/common'
import { CvcTextField, Popover, QuestionIcon, Small } from 'main/ui'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Container } from './CvcField.styles'

interface IProps {
  validationHint?: string
  value: string
  onChange: (value: string) => void
}

function CvcField(props: IProps) {
  const { validationHint, value, onChange } = props

  const [open, setOpen] = React.useState<boolean>(false)

  return (
    <Container>
      <CvcTextField
        label="CVC"
        placeholder="123"
        validationHint={validationHint}
        value={value}
        onChange={onChange}
        required
      />

      <Popover body={<PopoverBody />} isOpen={open} onRequestClose={() => setOpen(false)}>
        <div
          css={{ height: 24, width: 24 }}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          <QuestionIcon />
        </div>
      </Popover>
    </Container>
  )
}

function PopoverBody() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  return <Small>{t(`${PRE}-CREDIT-CARD-FORM-CVC-TOOLTIP`)}</Small>
}

export default React.memo(CvcField)
